
function __timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export { __timeout }